import { type HTMLAttributes, type ReactNode } from 'react'
import styles from './Card.module.css'

interface Props extends HTMLAttributes<HTMLDivElement> {
  titolo?: ReactNode
  azione?: ReactNode
  padding?: 'none' | 'sm' | 'md' | 'lg'
}

export function Card({ titolo, azione, padding = 'md', children, className, ...rest }: Props) {
  const classi = [styles.card, styles[`pad-${padding}`], className].filter(Boolean).join(' ')
  return (
    <div className={classi} {...rest}>
      {(titolo || azione) && (
        <div className={styles.header}>
          {titolo && <h3 className={styles.title}>{titolo}</h3>}
          {azione && <div>{azione}</div>}
        </div>
      )}
      {children}
    </div>
  )
}
